import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Upload } from "../icons";
import { CheckDuplicity } from "../services/btc-api.service";

export default function PersonalInfoForm({
  getUniqueSrNo,
  onNext,
  personalInfoData,
  handleImageChange,
  handleAlternateImageChange,
  handleInputChange,
  handleDateOfBirthChange,
}) {
  const [errors, setErrors] = useState({});

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isNumeric = (value) => {
    const numericRegex = /^\d+$/;
    return numericRegex.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!personalInfoData.userId) newErrors.userId = "User ID is required.";
    if (!personalInfoData.firstName)
      newErrors.firstName = "First name is required.";
    if (!personalInfoData.lastName)
      newErrors.lastName = "Last name is required.";
    if (!personalInfoData.gender) newErrors.gender = "gender is required.";
    if (!isEmailValid(personalInfoData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!personalInfoData.email) newErrors.email = "Email is required.";
    if (!personalInfoData.selectedDateOfBirth)
      newErrors.selectedDateOfBirth = "Date Of Birth is required.";
    if (!personalInfoData.selectedImage)
      newErrors.selectedImage = "FrontIdFile is required.";
    if (!personalInfoData.alternateselectedImage)
      newErrors.alternateselectedImage = "BackIdFile is required.";
    if (!personalInfoData.contactNumber) {
      newErrors.contactNumber = "Whatsapp number is required.";
    } else if (!isNumeric(personalInfoData.contactNumber)) {
      newErrors.contactNumber =
        "Whatsapp number should only contain numeric values.";
    }
    if (!personalInfoData.alternateContactNumber) {
      newErrors.alternateContactNumber = "Telephone number is required.";
    } else if (!isNumeric(personalInfoData.alternateContactNumber)) {
      newErrors.alternateContactNumber =
        "Telephone number should only contain numeric values.";
    }
    if (!personalInfoData.streetAddress)
      newErrors.streetAddress = "Street Address is required.";
    if (!personalInfoData.zipCode) newErrors.zipCode = "Zipcode is required.";
    if (!personalInfoData.city) newErrors.city = "city is required.";
    if (!personalInfoData.state) newErrors.state = "state  is required.";
    if (!personalInfoData.country) newErrors.country = "Country is required.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      try {
        const isDublicate = await CheckDuplicity({
          contactNumber: personalInfoData.contactNumber,
          secondaryContactNumber: personalInfoData.alternateContactNumber,
          email: personalInfoData.email,
        });

        if (isDublicate === undefined && isDublicate) {
          return;
        } else {
          await onNext();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const countryCodes = [
    {
      name: "Canada",
      dial_code: "+1",
      code: "CA",
    },
    {
      name: "Cayman Islands",
      dial_code: "+345",
      code: "KY",
    },
    {
      name: "China",
      dial_code: "+86",
      code: "CN",
    },
    {
      name: "Afghanistan",
      dial_code: "+93",
      code: "AF",
    },
    {
      name: "Aland Islands",
      dial_code: "+358",
      code: "AX",
    },
    {
      name: "Denmark",
      dial_code: "+45",
      code: "DK",
    },
    {
      name: "Hong Kong",
      dial_code: "+852",
      code: "HK",
    },
    {
      name: "Iceland",
      dial_code: "+354",
      code: "IS",
    },
    {
      name: "India",
      dial_code: "+91",
      code: "IN",
    },
    {
      name: "Indonesia",
      dial_code: "+62",
      code: "ID",
    },
    {
      name: "Ireland",
      dial_code: "+353",
      code: "IE",
    },
    {
      name: "Italy",
      dial_code: "+39",
      code: "IT",
    },
    {
      name: "Japan",
      dial_code: "+81",
      code: "JP",
    },
    {
      name: "Kuwait",
      dial_code: "+965",
      code: "KW",
    },
    {
      name: "Mexico",
      dial_code: "+52",
      code: "MX",
    },
    {
      name: "Norway",
      dial_code: "+47",
      code: "NO",
    },
    {
      name: "Oman",
      dial_code: "+968",
      code: "OM",
    },
    {
      name: "Pakistan",
      dial_code: "+92",
      code: "PK",
    },
    {
      name: "Poland",
      dial_code: "+48",
      code: "PL",
    },
    {
      name: "Portugal",
      dial_code: "+351",
      code: "PT",
    },
    {
      name: "Romania",
      dial_code: "+40",
      code: "RO",
    },
    {
      name: "Russia",
      dial_code: "+7",
      code: "RU",
    },
    {
      name: "UAE",
      dial_code: "+971",
      code: "UAE",
    },
  ];
  useEffect(() => {
    getUniqueSrNo();
    const middleOfPage = window.innerHeight / 2;
    window.scrollTo(0, middleOfPage);
  }, []);

  return (
    <div className="container">
      <p className="heading">Personal Information</p>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-5 col-lg-6 ">
          <input
            type="text"
            name="userId"
            disabled
            placeholder="USER ID"
            className={`border ${errors.userId ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.userId}
            onChange={handleInputChange}
          />
          {errors.userId && <p className="text-danger">{errors.userId}</p>}
        </div>
        <div className="col-12 col-md-5 col-lg-6 d-flex justify-content-center p-2">
          <label htmlFor="Male">
            <input
              type="radio"
              value={"female"}
              checked={personalInfoData.gender === "female"}
              name="gender"
              required
              id="Male"
              onChange={handleInputChange}
              className="radio-small "
            />{" "}
            <span>Male</span>
          </label>
          <div className="mx-5"></div>
          <label htmlFor="Female">
            <input
              type="radio"
              value={"male"}
              name="gender"
              checked={personalInfoData.gender === "male"}
              id="Female"
              required
              onChange={handleInputChange}
              className="radio-small"
            />{" "}
            <span>Female</span>
            {errors.gender && <p className="text-danger">{errors.gender}</p>}
          </label>
        </div>
      </div>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-5 col-lg-6 ">
          <input
            placeholder="First Name"
            type="text"
            name="firstName"
            className={`border ${errors.firstName ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.firstName}
            onChange={(e) => handleInputChange(e)}
          />
          {errors.firstName && (
            <p className="text-danger">{errors.firstName}</p>
          )}
        </div>
        <div className="col-12 col-md-5 col-lg-6">
          <input
            type="text"
            placeholder="Last Name"
            name="lastName"
            className={`border ${errors.lastName ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.lastName}
            onChange={handleInputChange}
          />
          {errors.lastName && <p className="text-danger">{errors.lastName}</p>}{" "}
        </div>
      </div>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-5 col-lg-6">
          <DatePicker
            showIcon
            name="selectedDateOfBirth"
            selected={personalInfoData.selectedDateOfBirth}
            onChange={handleDateOfBirthChange}
            placeholderText="Date of Birth"
            animation={false}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={90}
            className={`border ${errors.selectedDateOfBirth ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
          />
          {errors.selectedDateOfBirth && (
            <p className="text-danger">{errors.selectedDateOfBirth}</p>
          )}{" "}
        </div>
        <div className="col-12 col-md-5 col-lg-6">
          <input
            type="email"
            required
            name="email"
            placeholder="Email"
            className={`border ${errors.email ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.email}
            onChange={handleInputChange}
          />
          {errors.email && <p className="text-danger">{errors.email}</p>}
        </div>
      </div>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-5 col-lg-6">
          <div className="image-upload-container">
            <label htmlFor="image-upload-1" className="upload-label">
              {personalInfoData.selectedImage ? (
                <img
                  src={personalInfoData.selectedImage}
                  alt="Uploaded"
                  className="uploaded-image-2"
                />
              ) : (
                <div className="upload-placeholder-1">
                  <span>
                    <Upload />
                    Upload ID Card
                    <br /> Front Side
                  </span>
                </div>
              )}
            </label>
            <input
              name="selectedImage"
              type="file"
              id="image-upload-1"
              accept="image/*"
              className={`${errors.selectedImage ? "border-danger" : "border-secondary"
                } `}
              onChange={handleImageChange}
            />
          </div>
          {errors.selectedImage && (
            <p className="text-danger">{errors.selectedImage}</p>
          )}{" "}
        </div>
        <div className="col-12 col-md-5 col-lg-6 inputpadding">
          <div className="image-upload-container">
            <label htmlFor="image-upload-2" className="upload-label">
              {personalInfoData.alternateselectedImage ? (
                <img
                  src={personalInfoData.alternateselectedImage}
                  alt="Uploaded"
                  className="uploaded-image-2"
                />
              ) : (
                <div className="upload-placeholder-1">
                  <span>
                    <Upload />
                    Upload ID Card <br />
                    Back Side
                  </span>
                </div>
              )}
            </label>
            <input
              name="alternateselectedImage"
              type="file"
              id="image-upload-2"
              accept="image/*"
              className={` ${errors.alternateselectedImage
                ? "border-danger"
                : "border-secondary"
                }`}
              onChange={handleAlternateImageChange}
            />
          </div>
          {errors.alternateselectedImage && (
            <p className="text-danger">{errors.alternateselectedImage}</p>
          )}{" "}
        </div>
      </div>
      <div className="p-2 inputpadding phone-fields">
        <div className="whatsapp-phone">
          <div className="w-auto">
            <select
              name="selectedCountryCode"
              className="border border-secondary rounded country-code"
              value={personalInfoData.selectedCountryCode}
              onChange={handleInputChange}
            >
              {countryCodes.map((country) => (
                <option key={country.dial_code} value={country.dial_code}>
                  {country.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div className="whatsapp-phone-input">
            <input
              type="text"
              placeholder="Whatsapp number"
              name="contactNumber"
              className={`border ${errors.contactNumber ? "border-danger" : "border-secondary"
                } rounded mb-2 form-control`}
              value={personalInfoData.contactNumber}
              onChange={handleInputChange}
            />
            {errors.contactNumber && (
              <p className="text-danger">{errors.contactNumber}</p>
            )}
          </div>
        </div>
        <div className="whatsapp-phone">
          <div className="country-dropdown">
            <select
              name="alternateCountryCode"
              className="border border-secondary rounded country-code"
              value={personalInfoData.alternateCountryCode}
              onChange={handleInputChange}
            >
              {countryCodes.map((country) => (
                <option key={country.dial_code} value={country.dial_code}>
                  {country.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div className="whatsapp-phone-input">
            <input
              type="text"
              placeholder="Telephone number"
              name="alternateContactNumber"
              className={`border ${errors.alternateContactNumber
                ? "border-danger"
                : "border-secondary"
                } rounded mb-2 form-control`}
              value={personalInfoData.alternateContactNumber}
              onChange={handleInputChange}
            />
            {errors.alternateContactNumber && (
              <p className="text-danger">{errors.alternateContactNumber}</p>
            )}
          </div>
        </div>
      </div>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-10 col-lg-10">
          <input
            type="text"
            placeholder="Street Address"
            name="streetAddress"
            className={`border ${errors.streetAddress ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.streetAddress}
            onChange={handleInputChange}
          />
          {errors.streetAddress && (
            <p className="text-danger">{errors.streetAddress}</p>
          )}
        </div>
        <div className="col-12 col-md-10 col-lg-2">
          <input
            type="text"
            placeholder="Zip Code"
            name="zipCode"
            className={`border ${errors.zipCode ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.zipCode}
            onChange={handleInputChange}
          />
          {errors.contactNumber && (
            <p className="text-danger">{errors.zipCode}</p>
          )}
        </div>
      </div>
      <div className="row p-2 justify-content-center inputpadding">
        <div className="col-12 col-md-10 col-lg-4">
          <input
            type="text"
            placeholder="City"
            name="city"
            className={`border ${errors.city ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.city}
            onChange={handleInputChange}
          />
          {errors.city && <p className="text-danger">{errors.city}</p>}
        </div>
        <div className="col-12 col-md-10 col-lg-4">
          <input
            type="text"
            placeholder="Province"
            name="state"
            className={`border ${errors.state ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.state}
            onChange={handleInputChange}
          />
          {errors.state && <p className="text-danger">{errors.state}</p>}
        </div>
        <div className="col-12 col-md-10 col-lg-4">
          <input
            type="text"
            placeholder="Country"
            name="country"
            className={`border ${errors.country ? "border-danger" : "border-secondary"
              } rounded mb-2 form-control`}
            value={personalInfoData.country}
            onChange={handleInputChange}
          />
          {errors.country && <p className="text-danger">{errors.country}</p>}
        </div>
      </div>
      <div className="m-2 d-flex justify-content-center inputpadding">
        <div className="col-12 col-md-10 col-lg-10">
          <button type="submit" className="buttonstyle5" onClick={handleSubmit}>
            Next &nbsp; {">"}
          </button>
        </div>
      </div>
    </div>
  );
}
